export enum SRT_STATES {
    PENDING = 1,
    GENERATED = 2,
    ERROR = 3,
    CORRECTED = 4
}

export const SRT_STATES_OPTIONS = Object.entries(SRT_STATES)
    .filter(([_, value]) => 
        typeof value === 'number' && 
        value !== SRT_STATES.GENERATED
        // value !== SRT_STATES.CORRECTED
    )
    .map(([key, value]) => ({
        id: value as number,
        nombre: key.toLowerCase()
    }));
